export class ResponseError extends Error {
    constructor(code, message) {
        super(message);
        this.code = code;
        this.name = "ResponseError";
    }
}